// extracted by mini-css-extract-plugin
export default {"container":"style_container__vqzMr","title":"style_title__0Yds5","slider":"style_slider__rXpKv","value":"style_value__brq4N","resetButton":"style_resetButton__nTXLa"};